import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from '../app.constants';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HomeService {

    constructor(
        private _router: Router,
        private _http: Http,
        private _conf:Configuration
    ) { }


    profile() {
        var token = localStorage.getItem('authToken');
        let body = {
             token: token             
         };

        // console.log(body);
        
       

        return this._http.post(this._conf.Url + 'getUserProfile', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                // console.log("profile",res);

                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Home/home.service.ts
 **/